import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
@Injectable({
    providedIn: 'root',
})
export class LoginActivateGuard implements CanActivate {
    constructor(
        private authSvc: MsalService,
        private router: Router
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.authSvc?.instance?.getActiveAccount()?.idTokenClaims?.name == null) {
            this.router.navigate(['landing']);
        }
        return true;
    }
}
